import React, { useEffect, useState } from 'react';
import { Container, AppBar, Typography, Grow, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { getPosts } from './actions/posts';
import memories from './images/memories.png';
import Posts from './Components/Posts/Posts';
import Form from './Components/Form/Form';
import useStyles from './styles';

const App = () =>{

    const [currentId, setcurrentId] = useState(null);

    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPosts());
    }, [currentId, dispatch]);


  
  return (
  <Container maxidth='lg'>
      <AppBar className={classes.appBar} position='static' color='inherit'>
          <Typography className={classes.heading} variant='h2' align='center'>Memories</Typography>
          <img src={ memories } className={classes.image} alt='memories' height='60' />
      </AppBar>
      <Grow in> 
        <Container>
            <Grid container justify='space-between' className={classes.mainContainer} alignItems='stretch' spacing={3}> 
                <Grid item xs={12} sm={7}>
                    <Posts setcurrentId={ setcurrentId }/>
                </Grid>
                 <Grid item xs={12} sm={4}>
                    <Form currentId={ currentId } setcurrentId={ setcurrentId }/>
                </Grid>
            </Grid>
        </Container>
      </Grow>

  </Container>
  );
}

export default App;
